import { useRef } from 'react';
import { useField } from 'formik';
import { RcFile } from 'antd/lib/upload';
import { FileExcelOutlined, UploadOutlined, InboxOutlined } from '@ant-design/icons';
import type { UploadRequestOption } from 'rc-upload/lib/interface';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import Button from 'components/new-ui/base/button/Button';
import { StyledDragger } from 'components/new-ui/base/dragger/styles';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import { BrokerUploadSteps } from '../types';

const stepKey = BrokerUploadSteps.INVOICE;
const fieldName = 'invoice.invoiceFile';

const InvoiceStep = () => {
    const [field, , helpers] = useField(fieldName);
    const { isActive, isComplete, isIdle, resetStep } = useMultiStepFormContext<any>();
    const draggerRef = useRef<HTMLDivElement | null>(null);

    const value = field.value as RcFile | undefined;
    const sectionTitle = 'Invoice (Optional)';

    const handleUpload = (options: UploadRequestOption) => {
        helpers.setValue(options.file as RcFile);
    };

    const handleUploadClick = () => {
        const input = draggerRef.current?.querySelector('input[type="file"]') as HTMLInputElement | null;
        input?.click();
    };

    if (isIdle(stepKey)) {
        return <FormSectionHeader title={sectionTitle} icon={<FileExcelOutlined />} />;
    }

    if (isComplete(stepKey)) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormSectionHeader title={sectionTitle} icon={<FileExcelOutlined />} />
                <ReadonlyFormItem
                    disabled={false}
                    value={value?.name}
                    onReset={() => resetStep(stepKey, 'invoiceFile')}
                />
            </div>
        );
    }

    if (isActive(stepKey)) {
        return (
            <div>
                <FormSectionHeader
                    title={sectionTitle}
                    icon={<FileExcelOutlined />}
                    subtitle="You can upload your invoice here (optional)"
                    button={
                        <Button icon={<UploadOutlined />} onClick={handleUploadClick}>
                            Upload
                        </Button>
                    }
                />
                <div ref={draggerRef}>
                    <StyledDragger
                        style={{ marginTop: 8 }}
                        showUploadList={false}
                        maxCount={1}
                        customRequest={handleUpload}
                    >
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
                            <InboxOutlined style={{ fontSize: 24, color: 'var(--brand-6)' }} />
                            Click or drag file to this area to upload
                        </div>
                    </StyledDragger>
                </div>
            </div>
        );
    }

    return null;
};

export default InvoiceStep;
